import { Tooltip } from "@/components/ui/tooltip";
import { AppColors } from "@/styles/colors";
import { Button, Text } from "@chakra-ui/react";
import { memo, useCallback, useMemo } from "react";

interface DayCellProps {
  year: number;
  monthIndex: number;
  day: number;
  isBlocked: boolean;
  reasonsMap: Map<string, string>;
  onToggle: (dateKey: string) => void;
  canToggle?: boolean;
  disabled?: boolean;
}

export const DayCell =  memo(
  ({
    year,
    monthIndex,
    day,
    isBlocked,
    reasonsMap,
    onToggle,
    canToggle = true,
    disabled = false,
  }: DayCellProps) => {
    const dateKey = useMemo(() => {
      const pad2 = (n: number) => String(n).padStart(2, "0");
      return `${year}-${pad2(monthIndex + 1)}-${pad2(day)}`;
    }, [year, monthIndex, day]);

    const tooltipText = useMemo(() => {
      if (isBlocked) return reasonsMap.get(dateKey) || "Día bloqueado";
      return "Bloquear día";
    }, [isBlocked, reasonsMap, dateKey]);

    const handleClick = useCallback(() => {
      onToggle(dateKey);
    }, [onToggle, dateKey]);

    return (
      <Tooltip
        openDelay={300}
        closeDelay={100}
        positioning={{ placement: "top" }}
        content={<Text fontSize="12px">{tooltipText}</Text>}
        contentProps={{
          css: {
            paddingX: "10px",
            "--tooltip-bg": AppColors.BLACK_TEXT_SECONDARY,
          },
        }}
        disabled={disabled && !isBlocked}
      >
        <Button
          height="22px"
          width="100%"
          minW="0"
          paddingX="0"
          borderRadius="4px"
          onClick={canToggle ? handleClick : undefined}
          cursor={canToggle ? "pointer" : "default"}
          disabled={disabled}
          backgroundColor={
            isBlocked ? AppColors.RED_ICON_ALT : AppColors.BACKGROUND_SECONDARY
          }
          _hover={{
            backgroundColor: isBlocked
              ? AppColors.RED_ICON_ALT
              : AppColors.WHITE_BORDER_1,
          }}
        >
          <Text
            fontSize="12px"
            fontWeight={600}
            color={isBlocked ? "white" : AppColors.BLACK_TEXT_SECONDARY}
          >
            {day}
          </Text>
        </Button>
      </Tooltip>
    );
  },
);